/**
 * Enum de tipos de assinatura que o backend espera (tabela no banco),
 * todos em maiúsculo e exatamente iguais aos valores salvos.
 */
export enum TypeCompanySubscriptionType {
    NONE = 'NONE',       // Nenhum tipo de assinatura
    MONTHLY = 'MONTHLY', // Assinatura mensal
    ANNUAL = 'ANNUAL',   // Assinatura anual
    TRIAL = 'TRIAL',     // Assinatura de teste
    FREE = 'FREE',       // Assinatura gratuita
}

/**
 * Enum em português para exibição em grids e selects no frontend.
 */
export enum TypeCompanySubscriptionTypeBr {
    NONE = 'Nenhum',
    MONTHLY = 'Mensal',
    ANNUAL = 'Anual',
    TRIAL = 'Teste',
    FREE = 'Gratuito',
}

/**
 * Mapeia cada valor do enum para o texto exibido no frontend.
 * Ex.: "MONTHLY" -> "Mensal"
 */
export const TypeCompanySubscriptionTypeLabel: Record<TypeCompanySubscriptionType, string> = {
    [TypeCompanySubscriptionType.NONE]: 'Nenhum',
    [TypeCompanySubscriptionType.MONTHLY]: 'Mensal',
    [TypeCompanySubscriptionType.ANNUAL]: 'Anual',
    [TypeCompanySubscriptionType.TRIAL]: 'Teste',
    [TypeCompanySubscriptionType.FREE]: 'Gratuito',
};

/**
 * Mapeia cada valor do enum para uma cor padrão para exibição em badges no frontend.
 */
export const TypeCompanySubscriptionTypeColor: Record<TypeCompanySubscriptionType, string> = {
    [TypeCompanySubscriptionType.NONE]: '#808080',      // cinza
    [TypeCompanySubscriptionType.MONTHLY]: '#1E90FF',   // azul
    [TypeCompanySubscriptionType.ANNUAL]: '#228B22',    // verde
    [TypeCompanySubscriptionType.TRIAL]: '#FFA500',     // laranja
    [TypeCompanySubscriptionType.FREE]: '#20B2AA',      // verde água
};
